import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { StoreTransactionsPage } from "./-components/store-transactions-page";

const searchSchema = z.object({
  enableRefund: z.boolean().optional(),
});

type Search = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/store/transactions")({
  validateSearch: (search: Search) => searchSchema.parse(search),
  loader: ({ context: { client, company, store } }) => ({
    client,
    company,
    store,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { client, company, store } = Route.useLoaderData();
  const search = Route.useSearch();

  return (
    <StoreTransactionsPage
      client={client}
      companyId={company.id}
      enableRefundOverride={search.enableRefund === true}
      store={store}
    />
  );
}
